import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import LogoMakerThankYou from '@Components/LogoMaker/LogoMakerThankYou';
import { getStore } from '@Utils/core/redux/appStore';
import { UndoableLogoMakerModuleLoader } from '@Components/LogoMaker/logoMakerState';

const store = getStore();

const container = document.getElementById('plarium-logo-maker-thank-you');

if (container) {
  const root = createRoot(container);
  root.render(
    <>
      <Provider store={store}>
        <UndoableLogoMakerModuleLoader>
          <LogoMakerThankYou />
        </UndoableLogoMakerModuleLoader>
      </Provider>
    </>,
  );
}
